export default context => {
    let counter = 0;
    const container = $('.tickets-wrapper', context)
    if (container.length === 0) {
        return
    }

    const updateMembershipTab = () => {
        const $tab = $('a[href="#memberships"]', container)
        if ($tab.length === 0) {
            return
        }
        const $cb = context.find('input#editgroup-membership_purchase')
        if ($cb.is(':checked')) {
            container.find('a[href="#tickets"]').addClass('disabled').attr('aria-disabled', true).data('tooltip-disabled', false)
            // container.find('nav a[href="#memberships"]').removeClass('disabled')
        } else {
            container.find('a[href="#tickets"]').removeClass('disabled').removeAttr('aria-disabled').data('tooltip-disabled', true)
            // if (container.find('.tickets-form .ticket-info input[name$="[is_enabled]"]:checked').length >= 1) {
            //     container.find('nav a[href="#memberships"]').removeClass('disabled')
            // } else {
            //     container.find('nav a[href="#memberships"]').addClass('disabled')
            // }
        }
        container.find('nav').trigger('state-changed.coing')
    }
    const updateMembershipQuotas = () => {
        const $cb = $('input#editgroup-membership_purchase', context)
        $('#MembershipsOverviewList', context).attr('data-switch-value', $cb.is(':checked') ? 'fixed' : 'edit')
    }

    context.on('change', 'input#editgroup-membership_purchase', updateMembershipTab)
    context.on('change', 'input#editgroup-membership_purchase', updateMembershipQuotas)
    container.on('coing.ticket.added', updateMembershipTab)
    container.on('coing.ticket.enabled', updateMembershipTab)
    updateMembershipTab()
    updateMembershipQuotas()

    const updateMembershipOverview = () => {
        const table = $('#MembershipsOverviewList', context)
        const values = {}
        table.children('div[role=row]').each((i,e) => {
            values[$(e).data('id')] = $(e).find('input').val()
        })
        table.html('')
        const template = $($(table).data('template'), context).html()
        const source = $('table.tickets-memberships', context)
        if ($('a[href="#memberships"]', container).hasClass('disabled')) {
            return
        }
        source.find('tbody tr').each(function() {
            if ($(this).find('[data-name="is_enabled"] input[type=checkbox]:checked').length === 0) {
                return
            }
            const get = name => $(this).find(`[data-name=${name}]`).text()
            const id = $(this).data('id')
            const quota = id in values
                ? values[id]
                : get('quota')
            let row = template
                .replaceAll('{id}', id)
                .replaceAll('{quota}', quota)
                .replaceAll('{type}', get('type'))
                .replaceAll('{name}', get('name'))
                .replaceAll('{price}', get('price'))
                .replaceAll('{fixed_quota}', get('fixed-quota'))
                .replaceAll('{used-quota}', get('used-quota'))
            // $(this).find('td').each(function (i, e) {
            //     row = row.replaceAll(`{${i}}`, $(this).text())
            // })
            table.append(row)
        })
        updateTotal()
    }

    const updateExistingTickets = () => {
        const enabled = $('table.tickets-memberships [data-name="is_enabled"] input[type=checkbox]:checked', context)
            .map((i, em) => $(em).closest('.ticket-form-item').data('id')).get().join(',')
        $('.tickets-form', context).find('[data-name=memberships] input').val(enabled)
    }

    const updateRelatedTickets = () => {
        const current = $(':focus')
        if ($('#editgroup-membership_purchase', context).is(':checked')) {
        } else {
            updateExistingTickets()
        }
        current.focus()
    }

    const updateTotal = function() {
        let total = $('.tickets-wrapper .tickets-form .ticket-form-item:not(.disabled) .ticket-info [data-name=quota] input', context)
            .map((i, em) => parseInt($(em).val()) || 0).get()
            // 0 in any row must set result to 0.
            .reduce((acc, cval) => (cval > 0 && acc >= 0) ? acc + cval : -1, 0)
        total = $('#MembershipsOverviewList[data-switch-value="edit"] input', container)
            .map((i, em) => parseInt($(em).val()) || 0).get()
            .reduce((acc, cval) => (cval > 0 && acc >= 0) ? acc + cval : -1, total)
        total = $('#MembershipsOverviewList[data-switch-value="fixed"] .fixed-quota', container)
            .map((i, em) => parseInt($(em).text()) || 0).get()
            .reduce((acc, cval) => (cval > 0 && acc >= 0) ? acc + cval : -1, total)
        // total = total > 0 ? total : '';
        const max = $('#editgroup-max_members', context)
        //max must override total
        const maxVal = parseInt(max.val())
        if (maxVal > 0) {
            total = total > 0 ? Math.min(total, maxVal) : maxVal
        }
        $('#TicketsTotalAvailable').text(isNaN(total) || total < 1 ? window.translate.no_total_limit : total)
    }

    $('.tickets-memberships [data-name="is_enabled"] input[type=checkbox]', container).on('change', updateRelatedTickets)
    $('.tickets-memberships [data-name="is_enabled"] input[type=checkbox]', container).on('change', updateMembershipOverview)
    // $('section[data-tab="overview"]', context).on('shown.coing.tabs', updateMembershipOverview)

    $('nav', container).on('state-changed.coing', updateMembershipOverview)

    $('.edit-group-form', context).on('beforesubmit.coing', updateRelatedTickets)

    $('.tickets-wrapper').on('change', 'input', updateTotal)
    $('#MembershipsOverviewList', container).on('change', 'input', updateRelatedTickets)

    updateMembershipOverview()
    updateRelatedTickets()
    updateTotal()

}
